"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccommodationDescription = void 0;
const validator_1 = require("@leavy/validator");
const infrastructure_1 = require("../../../infrastructure");
const utils_1 = require("@leavy/utils");
const AccommodationQuality_1 = require("./AccommodationQuality");
const AccommodationCapacity_1 = require("./AccommodationCapacity");
const AccommodationBedding_1 = require("./AccommodationBedding");
const AccommodationRent_1 = require("./AccommodationRent");
const AccommodationLocation_1 = require("./AccommodationLocation");
const AccommodationAccesses_1 = require("./AccommodationAccesses");
const AccommodationAmenities_1 = require("./AccommodationAmenities");
class AccommodationDescription extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.rent) && this.rent.isComplete()
            && utils_1.Guard.isNotNullish(this.location) && this.location.isComplete()
            && utils_1.Guard.isNotNullish(this.amenities) && this.amenities.isComplete()
            && utils_1.Guard.isNotNullish(this.quality) && this.quality.isComplete()
            && utils_1.Guard.isNotNullish(this.capacity) && this.capacity.isComplete()
            && utils_1.Guard.isNotNullish(this.bedding) && this.bedding.isComplete()
            && utils_1.Guard.isNotNullish(this.accesses) && this.accesses.isComplete());
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => AccommodationRent_1.AccommodationRent),
    __metadata("design:type", AccommodationRent_1.AccommodationRent)
], AccommodationDescription.prototype, "rent", void 0);
__decorate([
    (0, validator_1.Type)(() => AccommodationLocation_1.AccommodationLocation),
    __metadata("design:type", AccommodationLocation_1.AccommodationLocation)
], AccommodationDescription.prototype, "location", void 0);
__decorate([
    (0, validator_1.Type)(() => AccommodationAmenities_1.AccommodationAmenities),
    __metadata("design:type", AccommodationAmenities_1.AccommodationAmenities)
], AccommodationDescription.prototype, "amenities", void 0);
__decorate([
    (0, validator_1.Type)(() => AccommodationQuality_1.AccommodationQuality),
    __metadata("design:type", AccommodationQuality_1.AccommodationQuality)
], AccommodationDescription.prototype, "quality", void 0);
__decorate([
    (0, validator_1.Type)(() => AccommodationCapacity_1.AccommodationCapacity),
    __metadata("design:type", AccommodationCapacity_1.AccommodationCapacity)
], AccommodationDescription.prototype, "capacity", void 0);
__decorate([
    (0, validator_1.Type)(() => AccommodationBedding_1.AccommodationBedding),
    __metadata("design:type", AccommodationBedding_1.AccommodationBedding)
], AccommodationDescription.prototype, "bedding", void 0);
__decorate([
    (0, validator_1.Type)(() => AccommodationAccesses_1.AccommodationAccesses),
    __metadata("design:type", AccommodationAccesses_1.AccommodationAccesses)
], AccommodationDescription.prototype, "accesses", void 0);
exports.AccommodationDescription = AccommodationDescription;
//# sourceMappingURL=AccommodationDescription.js.map